
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rank-predictor-terms",
      function () {
        return require("private-next-pages/rank-predictor-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rank-predictor-terms"])
      });
    }
  